import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CompliancyStatusIcon = ({ status, large = true }) => (
  <i
    className={classNames({
      'fa fa-fw': true,
      'fa fa-lg': large,
      'fa-times red': status === 0,
      'fa-warning orange': status === 1,
      'fa-check green': status === 2,
      'fa-times-circle text-grey': status === 3,
    })}
  />
);

CompliancyStatusIcon.propTypes = {
  status: PropTypes.oneOf([undefined, 0, 1, 2, 3]),
  large: PropTypes.bool,
};

CompliancyStatusIcon.defaultProps = {
  status: undefined,
  large: true,
};

export default CompliancyStatusIcon;
